import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { useGiftIdeaListing } from './hooks/useGiftIdeaListing'
import * as entities from '@boutique/entities'

export function Sort(): React.ReactElement | null {
  const {
    response,
    query: { sort },
    apply,
    setSort,
  } = useGiftIdeaListing()

  const total = response.data?.nbHits

  const defaultOption = entities.search.SORT_OPTIONS[0]
  const selectedOption = entities.search.SORT_OPTIONS.find((option) => option.value === sort) ?? defaultOption
  const selected = [selectedOption.value]

  return (
    <Wrapper id="top">
      <Total>{total?.toLocaleString() ?? <plume.Spinner small />} produits triés par</Total>
      <plume.Dropdown
        native
        mode="inline"
        onChange={(selection) =>
          apply(setSort(selection[0].value === defaultOption.value ? undefined : selection[0].value))
        }
        status="focused"
        selected={selected}
      >
        {entities.search.SORT_OPTIONS.map((sortOption) => (
          <plume.Option native key={sortOption.value} {...sortOption}>
            {sortOption.label}
          </plume.Option>
        ))}
      </plume.Dropdown>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  align-items: center;
  align-self: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;

  ${plume.Dropdown} {
    z-index: 1;
    ${plume.styles.select.Drawer} {
      left: unset;
      right: 0px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    justify-content: flex-end;
  }
`

const Total = styled.div`
  align-items: center;
  display: flex;
  font-weight: bold;
  margin-right: 8px;
  position: relative;
  top: -1px;
  width: 50%;
  justify-content: center;
  text-align: center;

  ${plume.Spinner} {
    position: relative;
    right: 15px;
    top: 1px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    width: auto;
  }
`
